export enum BookingStatus {
	Active = 1,
	Cancelled = 2,
}
